// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import Currency from '../../../../shared/components/currency';
import {FormattedMessage} from 'react-intl';

const buildClassName = isTotal => isTotal ?
    'value-of-repair-row total' :
    'value-of-repair-row';

const ValueOfRepairRow = ({isTotal = false, ...props}) =>
    <section className={buildClassName(isTotal)}>
        <span className='label'>
            <FormattedMessage id={props.label}/>
        </span>
        <Currency className='net'>{props.netValue}</Currency>
        <Currency className='list'>{props.listValue}</Currency>
    </section>;

ValueOfRepairRow.displayName = 'ValueOfRepairRow';
ValueOfRepairRow.propTypes = {
    isTotal: PropTypes.bool,
    label: PropTypes.string.isRequired,
    listValue: PropTypes.number.isRequired,
    netValue: PropTypes.number.isRequired
};

export default ValueOfRepairRow;



// WEBPACK FOOTER //
// ./src/claim/spa/components/value-of-repair/row.js